import { CancelPolicyRule } from "@graphql/types";
import { t } from "@helpers/translate";

interface getCancelPolicyTextItem {
  id: string;
  isRefundable: boolean;
  text: string;
}

export const getCancelPolicyText = (
  baseRules: CancelPolicyRule[]
): getCancelPolicyTextItem[] => {
  const rules = [...baseRules];
  if (rules.length === 0) {
    return [
      {
        id: "no-refund",
        isRefundable: false,
        text: t({
          id: "cancel-policy.rule.no-refund",
          message: "Non-refundable after your booking is confirmed",
        }),
      },
    ];
  }

  rules.push({
    from: rules[rules.length - 1].to,
    to: 0,
    charge: 0,
  });

  return rules
    .map((rule) => {
      // Full refund
      if (rule.charge === 0) {
        // display in hours
        if (rule.from < 3) {
          const hours = (rule.from + 1) * 24;
          return {
            id: "free-cancel-hours",
            isRefundable: true,
            text: t({
              id: "cancel-policy.rule.free-cancel-hours",
              message: `Free cancellation - ${hours} hours prior to meeting time`,
            }),
          };
        }

        // display in days
        const days = rule.from + 1;
        return {
          id: "free-cancel-days",
          isRefundable: true,
          text: t({
            id: "cancel-policy.rule.free-cancel-days",
            message: `Free cancellation - ${days} days prior to meeting time`,
            values: {
              days: `${days}`,
            },
          }),
        };
      }

      // No refund
      if (rule.charge === 100) {
        if (rule.to < 2) {
          const hours = (rule.from + 1) * 24;
          return {
            id: "no-refund-hours",
            isRefundable: false,
            text: t({
              id: "cancel-policy.rule.no-refund-hours",
              message: `No Refund -  less than - ${hours} hours before the meeting time`,
              values: {
                hours: `${hours}`,
              },
            }),
          };
        }

        const days = rule.to;
        return {
          id: "no-refund-days",
          isRefundable: false,
          text: t({
            id: "cancel-policy.rule.no-refund-days",
            message: `No Refund -  Within ${days} day(s) prior to meeting time`,
            values: {
              days: `${days}`,
            },
          }),
        };
      }

      const refund = 100 - rule.charge;
      const days = rule.from;

      if (rule.from === rule.to) {
        return {
          id: "refund-days",
          isRefundable: true,
          text: t({
            id: "cancel-policy.rule.refund-days",
            message: `${refund}% Refund - ${days} day(s) prior to meeting time`,
            values: {
              refund: `${refund}`,
              days: `${days}`,
            },
          }),
        };
      }

      const from = rule.from;
      const to = rule.to;

      return {
        id: "refund-from-to",
        isRefundable: true,
        text: t({
          id: "cancel-policy.rule.refund-from-to",
          message: `${refund}% Refund - ${from} to ${to} days prior to meeting time`,
          values: {
            refund: `${refund}`,
            from: `${from}`,
            to: `${to}`,
          },
        }),
      };
    })
    .reverse();
};
